import AccordionItemPrimary from "../../common/accordion-item/accordion-item-primary/accordion-item-primary";
import type { TTenderhubMediaPublicationItem } from "../../../types/tenderhub";

type Props = {
  items?: TTenderhubMediaPublicationItem[] | null;
};

const TenderhubMediaSection = ({ items }: Props) => {
  const publications = Array.isArray(items) ? items : [];
  return (
    <AccordionItemPrimary title="мы в медиаполе">
      <ul className="tenderhub-content-list__list">
        {publications.map((item) => (
          <li key={item.id}>
            <a
              href={item.url}
              className="link"
              target="_blank"
              rel="noreferrer"
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </AccordionItemPrimary>
  );
};

export default TenderhubMediaSection;

